import { Link } from "react-router-dom";
import { T } from "../lib/theme";

const cols = {
  Product: ["Features", "Pricing", "Changelog", "Roadmap"],
  Resources: ["Documentation", "API Reference", "Blog", "Help Center"],
  Company: ["About Us", "Careers", "Press Kit", "Contact"],
  Legal: ["Privacy Policy", "Terms of Service", "Cookie Policy", "GDPR"],
};

export default function Footer() {
  return (
    <footer
      style={{
        background: "#fff",
        borderTop: `1px solid ${T.border}`,
        padding: "4rem clamp(1rem,5vw,2rem) 2rem",
      }}
    >
      <div style={{ maxWidth: 1160, margin: "0 auto" }}>
        <div
          className="footer-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
            gap: "2.5rem",
            marginBottom: "2.5rem",
          }}
        >
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: "1rem",
              }}
            >
              <img src="/logo_min.png" alt="footer-logo" />
            </div>
            <p
              style={{
                color: T.textMuted,
                fontSize: "0.83rem",
                lineHeight: 1.7,
                maxWidth: 220,
                marginBottom: "1.2rem",
              }}
            >
              Modern veterinary practice management. Built for efficiency,
              designed for care.
            </p>
            <div style={{ display: "flex", gap: 8 }}>
              <a
                rel="noreferrer"
                href="https://www.facebook.com/profile.php?id=61591140047976"
                target="_blank"
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    cursor: "pointer",
                    background: T.bgSection,
                    border: `1px solid ${T.border}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = T.accentLight;
                    e.currentTarget.style.borderColor = T.accentMid;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = T.bgSection;
                    e.currentTarget.style.borderColor = T.border;
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={T.textMuted}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                  </svg>
                </div>
              </a>

              {/* {[
                "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z",
                "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37zM17.5 6.5h.01M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9A5.5 5.5 0 0 1 16.5 22h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2z",
                "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2zM4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
              ].map((p, i) => (
                <div
                  key={i}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    cursor: "pointer",
                    background: T.bgSection,
                    border: `1px solid ${T.border}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = T.accentLight;
                    e.currentTarget.style.borderColor = T.accentMid;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = T.bgSection;
                    e.currentTarget.style.borderColor = T.border;
                  }}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={T.textMuted}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d={p} />
                  </svg>
                </div>
              ))} */}
            </div>
          </div>
          {Object.entries(cols).map(([sec, items]) => (
            <div key={sec}>
              <div
                style={{
                  fontFamily: T.fonts.display,
                  fontWeight: 400,
                  fontSize: "0.80rem",
                  color: T.textHead,
                  marginBottom: "1rem",
                  letterSpacing: "0.02em",
                }}
              >
                {sec}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
                {items.map((item) => (
                  <Link
                    key={item}
                    to="#"
                    style={{
                      color: T.textMuted,
                      textDecoration: "none",
                      fontSize: "0.82rem",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.color = T.accentDark)
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.color = T.textMuted)
                    }
                  >
                    {item}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div
          style={{
            borderTop: `1px solid ${T.border}`,
            paddingTop: "1.4rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          <p style={{ color: "#aabfd0", fontSize: "0.76rem", margin: 0 }}>
            © 2026 PetPulse. All rights reserved. Made with ♥ for veterinary
            professionals.
          </p>
          <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
            <div
              style={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: "#34c98a",
                boxShadow: "0 0 6px rgba(52,201,138,0.7)",
              }}
            />
            <span style={{ color: "#aabfd0", fontSize: "0.74rem" }}>
              All systems operational
            </span>
          </div>
        </div>
      </div>
      <style>{`
        @media(max-width:900px){.footer-grid{grid-template-columns:1fr 1fr!important;}}
        @media(max-width:500px){.footer-grid{grid-template-columns:1fr!important;}}
      `}</style>
    </footer>
  );
}
